import { render, staticRenderFns } from "./channelDescriptionBlock.vue?vue&type=template&id=1fb3323e&"
import script from "./channelDescriptionBlock.vue?vue&type=script&lang=ts&"
export * from "./channelDescriptionBlock.vue?vue&type=script&lang=ts&"
import style0 from "./channelDescriptionBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports